/**
 * This is just a component, remove the validation logic
 * TODO: Replace ProductCartForm with this component
 */
import React from 'react';
import classnames from 'classnames';

const Discount = (props) => {
  const { label, value, subtotal, alwaysShow } = props;
  if (!alwaysShow && (value == undefined || value == null)) return null;

  return (
    <>
      { (
        <div>
          <span className="cart-property">{'Subtotal'}:</span>
          <span className="cart-amount order-subtotal"> {subtotal}</span>
        </div>
      )}
      <div>
        <span className="cart-property">{label || 'Discount'}:</span>
        <span className="cart-amount product-discount"> {value}</span>
      </div>
    </>
  )
}

const ProductCartForm = (props) => {
  const properties = props.properties || [];
  const { unitPrice, totalPrice } = props;
  const { discountLabel, discountValue, discountSubtotal, discountAlwaysShow } = props;
  const { onAddToCart } = props;

  const onClick = () => {
    if (onAddToCart) {
      onAddToCart();
    }
  }
  return (
    <div className="inside-product-cart">
      <span className="selection-label px-3 py-2 d-block">Pricing Information</span>

      {properties.map((p, idx) => (
        <div key={idx} className="form-inline product-property ps-3 pe-2 mb-2">
          <div className="form-group">
            <span className="product-property-label fw-bold">{p.label}</span>
            <span className="product-property-value">{p.value}</span>
          </div>
        </div>
      ))}

      <div className="inside-product-cart-b">
        <hr className="product-unit-price-separator" />
        <div>
          <span className="cart-property">Unit Price:</span>
          <span className={classnames("cart-amount product-unit-price", {
            "discounted": discountValue
          })}> {unitPrice}</span>
        </div>
        <Discount
          label={discountLabel}
          value={discountValue}
          subtotal={discountSubtotal}
          alwaysShow={discountAlwaysShow}/>
        <div className="total ps-3 py-2 mt-3 mb-4">
          <span className="product-total-label">Total:</span>
          <span className="product-total"> {totalPrice}</span>
        </div>
      </div>
      <input type="button"
        className="btn btn-main-action fw-bold text-uppercase ms-3 mb-3"
        onClick={onClick}
        value="Add To Cart" />
    </div>
  );
}

ProductCartForm.defaultProps = {
  discountAlwaysShow: false,
}

export default ProductCartForm;
